import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks"
import { selectDefectToEditImages } from "../../store/selectors/defectSelectors";
import { setToEditImages, updateItem } from "../../store/slices/defectSlice";
import { ImagesDialog } from "../Images/ImagesDialog";
import { Defect } from "../../types/defect";
import { updateDefect } from "../../services/defectService";

export const DefectImagesDialog = () => {
    const dispatch = useAppDispatch();

    const toEditImages = useAppSelector(selectDefectToEditImages);

    if (!toEditImages) {
        return null;
    }

    const onHide = () => {
        dispatch(setToEditImages(undefined));
    };

    const onSave = async (item: Defect) => {
        const updated = await updateDefect(item);

        if (updated) {
            dispatch(updateItem(item));
            onHide();
        }
    }

    return (
        <ImagesDialog item={toEditImages} onSave={onSave} onHide={onHide} />
    )
}